import React from 'react';
// import React, { Component } from 'react';
import { Field } from 'redux-form';

import classes from '../../../utils/cssClasses';
import RenderField from '../RenderField';

import style from './TagRepeater.scss';


// export default AlignamentRepeater;
export default function({fields}){
	return (
        <div>
            <div className={classes('row')}>
                {fields.map((tag, index) =>
                    <div className={classes('col-md-3')} key={index} >
                        <div className={classes('row no-gutters')}>
                            <div className={classes('col tag-field-editor',style)}>
                                <Field
                                    name={`${tag}`}
                                    type="text"
                                    component={RenderField}
                                    placeholder="Name"/>
                            </div>
                            <div className={classes('col-auto')}>
                                <div
                                    type="button"
                                    title="Remove Alignament"
                                    className={classes('btn btn-link text-danger btn-sm',style)}
                                    onClick={() => fields.remove(index)}>
                                    x
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            
            <button className={classes('btn btn-dark mt-3 mb-3 mx-0')} type="button" onClick={() => {
                fields.push("")
                console.log(fields.length);
            }}>Add item</button>
        </div>
	);
}


// WEBPACK FOOTER //
// ./src/components/Backend/TagRepeater/TagRepeater.js